module.exports = __webpack_public_path__ + "static/media/position-marker.7c61f045.svg";